import { withInstall } from '@jdesign-vue/utils'

import Popconfirm from './src/popconfirm.vue'

export const JdPopconfirm = withInstall(Popconfirm)
export default JdPopconfirm

export * from './src/popconfirm'
